import { imageUrlSchema } from '@crm/shared';
import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().min(1, 'Informe o e-mail').email('E-mail invalido'),
  password: z.string().min(1, 'Informe a senha'),
  rememberMe: z.boolean(),
});

export const registerSchema = z
  .object({
    name: z.string().min(2, 'Informe seu nome completo').max(80),
    email: z.string().min(1, 'Informe o e-mail').email('E-mail invalido'),
    password: z.string().min(8, 'A senha deve ter no minimo 8 caracteres').max(128),
    confirmPassword: z.string().min(1, 'Confirme a senha'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas nao conferem',
    path: ['confirmPassword'],
  });

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'Informe o e-mail').email('E-mail invalido'),
});

export const resetPasswordSchema = z
  .object({
    password: z.string().min(8, 'A senha deve ter no minimo 8 caracteres').max(128),
    confirmPassword: z.string().min(1, 'Confirme a senha'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas nao conferem',
    path: ['confirmPassword'],
  });

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Informe a senha atual'),
    newPassword: z.string().min(8, 'A senha deve ter no minimo 8 caracteres').max(128),
    confirmPassword: z.string().min(1, 'Confirme a nova senha'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'As senhas nao conferem',
    path: ['confirmPassword'],
  });

export const profileSchema = z.object({
  name: z.string().min(2, 'Informe seu nome completo').max(80),
  // A foto escolhida no aparelho chega como data URL e passa de 2048
  // caracteres com folga: com o limite antigo o formulario era recusado
  // sem dizer nada, e o botao de trocar foto parecia nao fazer nada.
  image: imageUrlSchema,
  phone: z.string().trim().max(40),
  gender: z.enum(['', 'FEMALE', 'MALE', 'UNDISCLOSED']),
  instagram: z.string().trim().max(120),
  facebook: z.string().trim().max(120),
  x: z.string().trim().max(120),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
export type RegisterFormValues = z.infer<typeof registerSchema>;
export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;
export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
export type ProfileFormValues = z.infer<typeof profileSchema>;
